export default __webpack_public_path__ + "static/media/Testimonial Model1.555b25d2.svg";